import { render } from "./NotificationSchedule.vue?vue&type=template&id=04679d6a&scoped=true"
import script from "./NotificationSchedule.vue?vue&type=script&lang=js"
export * from "./NotificationSchedule.vue?vue&type=script&lang=js"

import "./NotificationSchedule.vue?vue&type=style&index=0&id=04679d6a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04679d6a"]])

export default __exports__